import { useState } from 'react';
import { MemberFeeClient, MemberFeeDTO, ApiResponse_string, SearchRequestDTO_MemberFeeSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMemberFeeApi = () => {
    const apiClient = new MemberFeeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: MemberFeeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createMemberFee(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MemberFee');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: MemberFeeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateMemberFee(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating MemberFee');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMemberFeeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching MemberFee');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchMemberFees(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching MemberFees');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteMemberFee(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting MemberFee');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportMemberFees(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting MemberFees', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};